import $ from 'jquery';

require('lazysizes');
require('lazysizes/plugins/unveilhooks/ls.unveilhooks');

const gsap = require('gsap');
const TweenMax = gsap.TweenMax;


// Page transitions
import Swup from 'swup';
var options = {
    elements: ['#page']
};
const swup = new Swup(options);

var $hamburger = $(".hamburger");
var $item = $('.menu-item');
var $cover = $(".page-cover");
var $search = $(".input-search");
var $header = $("header");
var $offCanvas = $(".off-canvas-menu");

swup.on("clickLink", function(event) {
  if ($($hamburger).hasClass('is-active')) {
    $hamburger.toggleClass("is-active");
    $offCanvas.toggleClass("is-active");
  }
});

// Filter wine list
const List = require("list.js");

// Filter inventory
var filterList = function() {
  var options = {
    valueNames: [ 'wine', 'producer', 'country', 'region', 'variety', 'style' ]
  };

  var inventory = new List('inventory', options);
}

function addGradient() {
  var max = 4;
  var wines = $('.wine');
  var wineList = $('.wine-list').find('li');
  var wineContainer = $('.wine-list-container-overflow');

  if (wineList.length > max) {
    wineContainer.addClass('overflow-active');
  }
}

// Hide/show producer profile text
function hideText() {
  $('.producer-profile-text').each(function(){
    var max = 0;
    var readMoreButton = '<button class="read-more link-black t-sans ttu pt2 mb6">Read more</button>';
    var paragraphs = $(this).find('p:gt('+ max +')');

    if (paragraphs.length > max) {
      paragraphs.addClass('profile-paragraphs').hide().end()
        .append(
          $(readMoreButton).on("click", function(){
            $(this).toggleClass('active');
            if ($(this).hasClass('active')) {
              $(this).text('Read less');
              // $('.profile-paragraphs').addClass('visible');
              $('.profile-paragraphs').slideDown();
            } else {
              $(this).text('Read more');
              // $('.profile-paragraphs').removeClass('visible');
              $('.profile-paragraphs').slideUp();
            }
          })
      );
    } else {
      paragraphs.hide();
    }
  });
}

// Toggle wine list filters
function toggleFilters() {
  $('.toggle-wine-filters').on("click", function(e) {
    $('.wine-list-table-header').toggleClass("is-active");
    $('.filter-icon').toggleClass("is-active");
    e.stopPropagation();
  });
}

// Off-canvas menu
function toggleMenu() {
  $hamburger.on("click", function(e) {
    $(this).toggleClass("is-active");
    $offCanvas.toggleClass("is-active");

    if ($(this).hasClass('is-active')) {
      // console.log("Menu open");

      TweenMax.staggerFrom($item, 0.75, {
        opacity: 0,
        delay: 0.5,
        y: 50,
        ease: Cubic.easeOut
        }, 0.1
      );

    } else {
      // console.log("Menu close");
    }

    e.stopPropagation();
  });
}

// Scroll to top
function scrollToTop() {
  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
  });
}

function swapBgColor() {
  $(window).scroll(function(){
    var header = $(".header-bg-half-sticky-desktop");
    var information = $('.section-information');

    var header_position = header.offset().top;
    var header_height = header.height();

    var information_position = information.offset().top;
    var information_height = information.height();

    if (header_position > information_position) {
      header.removeClass('tan');
      header.addClass('white');
      // console.log('Overlaying info');
    } else {
      header.addClass('tan');
      header.removeClass('white');
      // console.log('Not overlaying info');
    }
  });
}


document.addEventListener('swup:contentReplaced', function () {
  filterList();
  hideText();
  scrollToTop();
  toggleFilters();
  addGradient();
  swapBgColor();
});

$(document).ready(function() {
  filterList();
  hideText();
  toggleFilters();
  toggleMenu();
  addGradient();
  swapBgColor();
});



// WEBPACK FOOTER //
// ./src/js/main.js